export function hasKey<O>(obj: O, key: string | number | symbol): key is keyof O {
    return !!(obj && typeof obj === 'object' && key in obj);
}
